export class LinkPaymentResource {
    public static $inject: string[] = [
        "$resource",
        "configService"
    ];

    constructor(
        $resource: any,
        configService: any
    ) {
        return (headers: any = {}) => {
            const url = `${configService.paymentApi.url}/v1/sales/:saleId/link_payment`;

            return $resource(`${url}`, { saleId: "@saleId", linkId: "@linkId" }, {
                create: {
                    method: "POST",
                    url,
                    headers
                },
                update: {
                    method: "PATCH",
                    url: `${url}/:linkId/renew`
                },
                delete: {
                    method: "DELETE",
                    url: `${url}/:linkId`
                }
            });
        };
    }
}

angular
    .module("thor.core.link-payment.resource", [])
    .factory("linkPaymentResource", LinkPaymentResource);
